import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Box, Button, Checkbox, Grid, IconButton, List, ListItem, ListItemText, Modal, TextField, ThemeProvider, Tooltip, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { ContextNotification, severitys } from '../../../App';
import customtheme from '../../../themes';
import { useSelector } from 'react-redux';
import RtlProvider from "../../../Components/RtlProvider"
import helper from "../../../helper";
import EditPackageDetail from "./EditPackageDetail";
import EnumMapper from "../../../EnumMapper";
import { useNavigate, useParams } from "react-router-dom";
import BeatLoading from "../../../Components/Loader/BeatLoader";
import { RiDeleteBin5Fill } from "react-icons/ri";
import ConfirmationDialog from '../../../Components/ConfirmationDialog';
import packageApi from "../../../api/packageApi";
import { TbEdit, TbPlaylistAdd } from "react-icons/tb";
import { BiTrip } from "react-icons/bi";
import CustomTitle from "../../../Components/CustomTitle";
import { TfiBackRight } from "react-icons/tfi";
import { useLocation } from "react-router-dom";
import staticData from "../../../data/StaticData";

const EditPackage = () => {

    const { open, setOpen } = useContext(ContextNotification);
    const [addEditType, setAddEditType] = useState(null);
    const [isloading, setIsloading] = useState(false);
    const customization = useSelector((state) => state.customization);
    const { id } = useParams();
    const [PackageDetails, setPackageDetails] = useState([]);
    const [selectedPackageDetail, setSelectedPackageDetail] = useState(null)
    const [showAddPacDetail, setShowAddPacDetail] = useState(false);
    const [duration, setDuration] = useState(0);
    const navigate = useNavigate();
    const schema = yup.object().shape({
        packageTitle: yup.string().trim().required(" عنوان برنامه سفر را وارد نمائید"),
        duration: yup.number().positive(" مدت اقامت را وارد نمائید")
    });
    const { register, setValue, handleSubmit, formState: { errors }, control, resetField, reset, getValues, watch } = useForm({
        resolver: yupResolver(schema),
    });
    const location = useLocation();
    useEffect(() => {
        RefreshForm();
    }, [location]);

    const AddEditPackage = () => {
        if (addEditType === EnumMapper.AddEditMode.Add) {

            let packagename = null;
            if (watch("packageTitle"))
                packagename = watch("packageTitle");

            const data = {
                "name": packagename,
                "duration": duration,
                "details": PackageDetails
            }
            setIsloading(true);
            packageApi.CustomCreate(data).then((res) => {

                if (res.data.success) {
                    setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
                    RefreshForm();
                }
                else {
                    setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
                }
            }).catch(err => {
                if (err.response && err.response.data && err.response.data.errors) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
                }
                else if (err.response && err.response.data) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
                }
                else if (err.message) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
                }
                else {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err), severity: severitys.error });
                }
            }
            ).finally(() => setIsloading(false));
        }
        else {
            let packagename = null;
            if (watch("packageTitle"))
                packagename = watch("packageTitle");

            const data = {
                "name": packagename,
                "duration": duration,
            }
            setIsloading(true);
            packageApi.EditPackage(id, data).then((res) => {

                if (res.data.success) {
                    setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
                    RefreshForm();
                }
                else {
                    setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
                }
            }).catch(err => {
                if (err.response && err.response.data && err.response.data.errors) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
                }
                else if (err.response && err.response.data) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
                }
                else if (err.message) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
                }
                else {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err), severity: severitys.error });
                }
            }
            ).finally(() => setIsloading(false));

        }
    }

    const GetPackage = (id) => {
        setIsloading(true);
        packageApi.GetPackageByID(id).then((res) => {
            if (res.data.success) {
                setValue("packageTitle", res.data.data.name);
                setDuration(res.data.data.duration);
                packageApi.GetPackageDetailByPackageID(res.data.data.id).then((res1) => {
                    if (res1.data?.success) {
                        setPackageDetails(res1.data.data);
                    }
                    else {
                        setOpen({ IsEnable: true, Message: res1.data.message, severity: severitys.error });
                    }
                }).catch(err1 => {
                    if (err1.response && err1.response.data && err1.response.data.errors) {
                        setOpen({ IsEnable: true, Message: JSON.stringify(err1.response.data.errors), severity: severitys.error });
                    }
                    else if (err1.response && err1.response.data) {
                        setOpen({ IsEnable: true, Message: JSON.stringify(err1.response.data), severity: severitys.error });
                    }
                    else if (err1.message) {
                        setOpen({ IsEnable: true, Message: JSON.stringify(err1.message), severity: severitys.error });
                    }
                    else {
                        setOpen({ IsEnable: true, Message: JSON.stringify(err1), severity: severitys.error });
                    }
                });
            }
            else {
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
            }
        }).catch(err => {
            if (err.response && err.response.data && err.response.data.errors) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.response && err.response.data) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }
            else {
                setOpen({ IsEnable: true, Message: JSON.stringify(err), severity: severitys.error });
            }
        }
        ).finally(() => setIsloading(false));
    }
    useState(() => {
        if (id) {
            setAddEditType(EnumMapper.AddEditMode.Edit);
            GetPackage(id);

        }

        else
            setAddEditType(EnumMapper.AddEditMode.Add);

    }, [])

    const onSubmit = () => {
        AddEditPackage();
        RefreshForm();
    }

    const RefreshForm = () => {
        if (id) {
            GetPackage(id);
            setAddEditType(parseInt(EnumMapper.AddEditMode.Edit));

        }
        else {
            setAddEditType(parseInt(EnumMapper.AddEditMode.Add));
        }
        setValue("packageTitle", null);
        setDuration(0);
        setPackageDetails([]);
        setSelectedPackageDetail(null);
        setShowAddPacDetail(false);
        setDeletePackageDetailID(null);
        setOpenDeleteModal(false);
        setDeletePackageDetailID(null);
    }

    ////////EditDetail

    const handleOpenEditPackageDetail = (item) => {

        if (addEditType === EnumMapper.AddEditMode.Edit) {
            if ((showAddPacDetail) && (item.id === selectedPackageDetail?.id)) {

                setSelectedPackageDetail(null);
                setShowAddPacDetail(false);
            }
            else {
                setSelectedPackageDetail(item);
                setShowAddPacDetail(true);
            }

        }
    }
    const AddPackageDetail = (packageDetaildata) => {
        var newOrder = PackageDetails.length > 0 ? Math.max(...PackageDetails.map(a => { return a.order })) + 1 : 0;
        const newitem = {
            "order": newOrder,
            "title": packageDetaildata.title,
            "events": packageDetaildata.events?.map(e => {
                return {
                    "description": e.description,
                    "eventType": e.eventType,
                    "fromCity": e.fromCity,
                    "toCity": e.toCity,
                    "startT": e.startT,
                    "endT": e.endT
                }
            })
        }
        setPackageDetails([...PackageDetails, newitem]);
    }
    //////////DeleteDetail
    const [deletePackageDetailId, setDeletePackageDetailID] = useState(null)
    const [openDeleteModal, setOpenDeleteModal] = useState(false);

    const hancleRemovePackageDetail = (id, order) => {
        if (addEditType === EnumMapper.AddEditMode.Add) {
            RemovePackageDetail(null, order);
        }
        else {
            setDeletePackageDetailID(id);
            setOpenDeleteModal(true);
        }
    }
    const handleCloseDeleteModal = () => {
        setOpenDeleteModal(false);
        setDeletePackageDetailID(true);
    }

    const RemovePackageDetail = (id, order) => {
        if (addEditType === EnumMapper.AddEditMode.Add) {
            const removedDetail = PackageDetails.filter((a) => a.order !== order);
            var ord = -1;
            const newDetail = removedDetail.sort((a, b) => a.order >= b.order ? 1 : -1).map((itm) => {
                ord = ord + 1;
                return {
                    "order": ord,
                    "title": itm.title,
                    "events": itm.events
                }

            });
            setPackageDetails(newDetail);
        }
        else {

        }
    }

    const handledurationChange = (event) => {
        var num = Number(event.target.value);
        if (Number.isNaN(num) || (num < 0))
            num = 0;
        setDuration(num);
    }
    const GoToPackageList = () => {
        navigate('/dashboard/PackageList');

    }

    return (
        <ThemeProvider theme={customtheme(customization)}>

            {(addEditType === EnumMapper.AddEditMode.Edit) &&
                <IconButton
                    sx={{ fontSize: '0.7rem', fontWeight: 'bold' }}

                    color="inherit" onClick={() => { GoToPackageList() }}>
                    <Typography component="h1" variant="h5" sx={{ display: "flex", alignItems: "center", fontSize: '12px' }}>
                        بازگشت به لیست برنامه سفر              </Typography>
                    < TfiBackRight size={20} />
                </IconButton>
            }
            <RtlProvider>
                <CustomTitle title={(addEditType === EnumMapper.AddEditMode.Add ? 'افزودن برنامه سفر' : 'ویرایش برنامه سفر')} icon={<BiTrip size={24} />} />
                <form onSubmit={handleSubmit(onSubmit)} >
                    <Grid container spacing={2}>
                        <Grid item md={12} xs={12}>
                            <TextField label="عنوان برنامه سفر" focused={true} onChange={(e) => { }} {...register("packageTitle")} sx={{ width: "250px" }} ></TextField>
                            <p className="error">{errors.packageTitle?.message}</p>
                        </Grid>
                        <Grid item md={5} xs={5}>
                            <TextField
                                sx={{ width: '100px' }}
                                type='number'
                                value={duration}
                                onChange={handledurationChange}
                                label="مدت اقامت (روز)"
                            />

                            {(addEditType === EnumMapper.AddEditMode.Add) && <Tooltip title={'افزودن مرحله سفر'}><IconButton edge="end" sx={{ mt: 1 }} aria-label=" مرحله سفر" onClick={() => { setShowAddPacDetail((old) => !(old)); }}>
                                <TbPlaylistAdd color='#4a148c' size={24} />
                            </IconButton>
                            </Tooltip>}

                            {(addEditType === EnumMapper.AddEditMode.Edit) && <Tooltip title={'ویرایش عنوان و مدت سفر'}><IconButton edge="end" sx={{ mt: 1 }} aria-label=" ویرایش سفر" onClick={() => { AddEditPackage(); }}>
                                <TbEdit color='#4a148c' size={24} />
                            </IconButton>
                            </Tooltip>}
                            <p className="error">{errors.duration?.message}</p>
                        </Grid>
                    </Grid>

                    {(showAddPacDetail && <Box style={{ display: 'flex', border: '1px solid gray', borderRadius: 7 }} sx={{ backgroundColor: '#ecfcffff', mt: 2 }}>
                        <EditPackageDetail AddEditType={addEditType} PackageDetail={selectedPackageDetail} AddPackageDetail={(data) => AddPackageDetail(data)} Refresh={RefreshForm} />
                        <IconButton
                            aria-label="بستن"
                            onClick={() => { setShowAddPacDetail(false); }}
                            sx={{
                                position: 'absolute',
                                left: 8,
                                top: 8,
                                color: '#04636E'
                            }}
                        ></IconButton>
                    </Box>)}

                    {(PackageDetails?.length > 0) && <>
                        <Typography component="h1" variant="h5" mt={2} mb={2} ml={1}  >
                            لیست مراحل سفر
                        </Typography>
                        <Box style={{ display: 'flex', border: '1px solid gray', borderRadius: 7 }} sx={{ mt: 1 }}>
                            <List sx={{ width: '100%' }}>
                                {PackageDetails?.sort((a, b) => a.order >= b.order ? 1 : -1).map((itm, index) => {
                                    return (
                                        <ListItem key={index} >
                                            <Grid container spacing={1}>
                                                <Grid item md={2} xs={3}>
                                                    <ListItemText sx={{ ml: 2 }} primary={' روز ' + staticData.Recorder[itm.order + 1]} />
                                                </Grid>
                                                <Grid item md={9} xs={6}>
                                                    <ListItemText sx={{ ml: 2 }} primary={itm.title} />
                                                </Grid>
                                                 <Grid item md={1} xs={3}>
                                                   {addEditType === EnumMapper.AddEditMode.Edit && <Tooltip title="ویرایش" placement="top">
                                                    <IconButton  onClick={() => {
                                                        handleOpenEditPackageDetail(itm);
                                                    }}>
                                                        <TbEdit color='#4a148c' />
                                                    </IconButton>
                                                </Tooltip>}
                                                    <IconButton disabled={isloading} edge="end" aria-label="حذف" onClick={() => { hancleRemovePackageDetail(itm.id, itm.order) }}>
                                                        <BeatLoading loading={isloading} color={"#e65100"}  />
                                                        <RiDeleteBin5Fill color='#C7253E' />
                                                    </IconButton>
                                                </Grid>
                                            </Grid>

                                        </ListItem>
                                    )
                                })
                                }
                            </List>
                        </Box></>}
                    {(addEditType === EnumMapper.AddEditMode.Add) && (PackageDetails?.length > 0) &&
                        <Button
                            type="submit"
                            style={{
                                fontSize: "18px",
                                width: "12rem",
                                height: "3rem",
                                backgroundColor: "#127c69ff",
                                color: "white",
                            }}
                            sx={{ m: 1 }}
                            disabled={isloading}

                        >
                            <BeatLoading loading={isloading} color={"#e65100"} size={8} />
                            ثبت  برنامه سفر                                 </Button>
                    }

                    <ConfirmationDialog
                        open={openDeleteModal}
                        handleClose={() => handleCloseDeleteModal()}
                        func={RemovePackageDetail}
                    />

                </form>


            </RtlProvider>
        </ThemeProvider>
    );

}
export default EditPackage;